import type { PropsWithChildren } from 'react';
import type React from 'react';
import styled from 'styled-components';

export const Header: React.FC<PropsWithChildren> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }): string => theme.palette.primary.main};
  width: 100%;
  pointer-events: none;
`;
